import { Dispatch, SetStateAction } from "react";

export interface PdfIntroTypes {
  untertitel: string;
  einleitung: string;
  themen: any;
  fusszeile: any;
}

const fetchIntroPages = async () => {
  try {
    const response = await fetch("/introdaction.json");
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const jsonData = await response.json();
    return jsonData
  } catch (error) {
    console.error('Error fetching data of pdf intoruction pages:', error);
  }
};

export const  getPdfIntroData = async (setPdfIntroData:  Dispatch<SetStateAction<PdfIntroTypes>>) => {
  const pdfIntrodactionData = await fetchIntroPages()
  setPdfIntroData(pdfIntrodactionData)
}